
//init
const extra = "<i>Still need help? Our Customer Service Advisors are more than happy to answer any further questions you may have. Simply pop your question in the enquiry box below and we'll take care of the rest.</i>";

const OrderQueries = {
    Order: "Your coffee is roasted fresh to order, and posted the same day. We aim to despatch all orders within two working days of you placing it. With delivery times considered, please allow up to five working days from when you order until it arrives at your door.",
    Missing: "",
    WrongItem: "",
    Delivery: "We aim to freshly roast and post all orders within two working days of you placing it. You should have received a confirmation email after you placed your order, and a following despatch email with a tracking link. With delivery times considered, please allow up to five working days from when you order until it arrives at your door."
}

const CoffeeClub = {
    ccSubscribe: "Thanks for your interest in our CoffeeClub subscription service. Learn more about fresh coffee with convinience by clicking here. <a href='https://unionroasted.com/pages/coffeeclub'> https://unionroasted.com/pages/coffeeclub </a>",
    ccGift: "Thanks for your interest in our CoffeeClub Gift subscription service. Learn more about easy and delicious gifts by clicking here. <a href='https://unionroasted.com/pages/how-coffeeclub-gifts-work'>https://unionroasted.com/pages/how-coffeeclub-gifts-work </a>",
    ccChange: "CoffeeClub is designed for your ease. Simply log on, click on your subscription and change the coffees you want to receive, the frequency you receive them at and of course pause or cancel if you want. ",
    ccCancel: "",
    ccAccess: ""
}

const Delivery = {
    notdelivered: "Your coffee is roasted fresh to order, and posted the same day. We aim to despatch all orders within two working days of you placing it. With delivery times considered, please allow up to five working days from when you order until it arrives at your door.",
    return: "Your coffee is roasted fresh to your order, so we do not accept returns or exchanges. We also cannot accept any responsibility for items ordered incorrectly on our website. Please check your order before payment, and confirmation email to ensure you've picked the correct coffee, grind type and delivery address. Not everything is freshly roasted... the same does not apply to any orders incorrectly fulfilled by us, any unused /unopened equipment or accessories. Please email us for these below to see if your order is eligible for a refund or exchange",
    foreign: "Let us investigate this for you. Please email us below with a picture of the back of your coffee bag with the \"PR number\" clearly visible as well as a picture of the foreign object. That will help our production team investigate this case immediately.",
    faulty: ""
}

const CoffeeInfo = {
    rightcoffee: "Let us tell you our top tips for picking your perfect coffee. Find it now: <a href='https://unionroasted.com/pages/how-to-choose-your-coffee'>https://unionroasted.com/pages/how-to-choose-your-coffee</a>",
    environment: "The future of people, planet and coffee drives what we do. Thank you for interest in our environmental and sustainability work. You can read more here: <a href='https://unionroasted.com/pages/impact-strategy'>https://unionroasted.com/pages/impact-strategy</a> .",
    farms: "An essential part of our union, responsible for that delicious cup of coffee in your hand. Read more about our farmer partners here: <a href='https://unionroasted.com/blogs/our-farmer-partners'>https://unionroasted.com/blogs/our-farmer-partners</a> . ",
    training: "We currently offer training modules for our Trade partners who are looking to train their staff and enhance the coffee experience for their own customers. You can find out more about this by clicking this link:  <a href='https://unionroasted.com/pages/wholesale-training-courses'>https://unionroasted.com/pages/wholesale-training-courses</a>"
}


const Wholesale = {
    business: "Thank you so much for considering us as a partner for you new business. Please follow this link to our Wholesale contact form and one of our Wholesale Team members will get in touch with you to answer all the questions you may have.",
    Retail: "Our list of partners is pretty extensive so please drop us an email below and let us know which area works best for you and we'll be happy to provide you with a tailored list of Cafés.",
    pickup: "We unfortunately do not have a shop on the premises or are able to allow for pick ups. You can purchase our coffee directly from our website or large retailers like Sainsbury's, Waitrose, Amazon and Ocado"
}



$(document).ready(function () {

    $('select').on("change", function () {
        $('.ansdiv , .msg').addClass("no-display");
        $(':input[type="submit"]').prop('disabled', true);
        //console.log("id :" + this.id);
        //console.log("value :" + this.value);
        //console.log("name :" + this.name);
        if (this.id == "lev3") {
            $('.lev4 select , .ansdiv').addClass("no-display");
            $(".lev4 select").attr('name', '');
            $(".lev4 #" + this.value).removeClass("no-display");
            $(".lev4 #" + this.value).attr('name', 'contact['+this.value+']');
            if (this.value == "Other") {

                $('.msg').removeClass("no-display");
                $(':input[type="submit"]').prop('disabled', false);

            }

        } else if (this.value) {

            var ans = eval(this.id)[this.value] + "<br>" + extra;
            //console.log("OO" + ans);

            $('.ansdiv .ans span').html(ans);
            $('.ansdiv, .msg').removeClass("no-display");
            $(':input[type="submit"]').prop('disabled', false);

        }
    });


    setTimeout(function () {
        $('select').selectric('destroy');
        $('.lev4 select , .ansdiv, .msg').addClass("no-display");
        $(':input[type="submit"]').prop('disabled', true);
        //console.log("++Support data loaded++");
    }, 2000);

});
